
<template>
  <div id="app">
    <nav-bar />
    <router-view />
    <b-button id="scroll-to-top" @click="scrollToTop()" variant="primary"> <font-awesome-icon :icon="['fas', 'arrow-up']" /><span class="sr-only">Press Here to go to Top of Page</span></b-button>
  </div>
</template>

<script>
import NavBar from "./components/NavBar.vue";

export default {
  name: "App",
  components: { NavBar },
  methods: {
    scrollToTop() {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#scroll-to-top {
  position: fixed;
  width: 50px;
  height: 50px;
  border-radius: 25px;
  bottom: 95px;
  right: 20px;
  z-index: 1;
}
</style>